import { useTranslation } from 'react-i18next';

import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import * as IngredientList from 'types/Recipe/Detail/ErpNew/IngredientList';

type IProps = RecipeErpViewComponentProps & {
	ingredientMapping: IngredientList.Type;
};

const SearchBar = (props: IProps) => {
	const { t } = useTranslation();

	return (
		<input
			type="text"
			className="form-control"
			placeholder={t('header:SEARCH') + ' ...'}
			value={props.state.searchTerm}
			onChange={(e) => {
				props.handlers.setSearchTerm(e.target.value);
			}}
		/>
	);
};

export default SearchBar;
